import React, { useEffect, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'

import Logo from '../../static/images/logo/logo.png'
import LogoScroll from '../../static/images/logo/only-logo.png'

const Navbar = () => {
  const location = useLocation()
  const [scroll, setScroll] = useState(false)
  const [mobile, setMobile] = useState(false)
  const [navWhite, setNavWhite] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 5)
    })

    const makeVisible = () => {}

    window.innerWidth > 800 ? setMobile(false) : setMobile(true)

    if (
      location.pathname === '/' ||
      location.pathname === '/about-us' ||
      location.pathname === '/about-us/industry' ||
      location.pathname === '/leadership'
    ) {
      setNavWhite(true)
    }
  }, [])

  return (
    <nav
      className={
        scroll
          ? 'navbar navbar-expand-lg fixed-top nav-scroll'
          : 'navbar navbar-expand-lg fixed-top'
      }
      id={navWhite ? 'white-nav' : ''}
    >
      <div
        className='container-fluid'
        data-aos={mobile ? '' : 'fade-down'}
        data-aos-delay={mobile ? '' : '300'}
      >
        <Link className='navbar-brand' to='/'>
          <img
            src={scroll ? LogoScroll : Logo}
            alt='Logo'
            className='img-fluid'
          />
          {/* Rean Watertech */}
        </Link>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarSupportedContent'
          aria-controls='navbarSupportedContent'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>
        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
          <ul className='navbar-nav mb-2 mb-lg-0 ms-auto'>
            <button
              className='closeBtn'
              data-bs-toggle='collapse'
              data-bs-target='#navbarSupportedContent'
            >
              <i className='bi bi-x-lg'></i>
            </button>
            <li className='nav-item'>
              <Link className='nav-link' aria-current='page' to='/'>
                Home
              </Link>
            </li>
            <li className='nav-item dropdown'>
              <div className='nav-link dropdown-toggle' to='#'>
                Company
              </div>
              <ul className='dropdown-menu' aria-labelledby='navbarDropdown'>
                <li>
                  <Link className='dropdown-item' to='/about-us'>
                    About Rean
                  </Link>
                </li>
                <li>
                  <Link className='dropdown-item' to='/leadership'>
                    Leadership
                  </Link>
                </li>
                {/* <li><hr className='dropdown-divider' /></li> */}
                <li>
                  <Link className='dropdown-item' to='/achievements-and-media'>
                    Accolades
                  </Link>
                </li>
                {/* <li>
                  <Link className='dropdown-item' to='/careers'>
                    Careers
                  </Link>
                </li> */}
              </ul>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' aria-current='page' to='/expertise'>
                Our Expertise
              </Link>
            </li>
            <li className='nav-item'>
              <Link className='nav-link' aria-current='page' to='/projects'>
                Projects
              </Link>
            </li>

            <li className='nav-item'>
              <Link className='nav-link' aria-current='page' to='/careers'>
                Careers
              </Link>
            </li>

            <li className='nav-item'>
              <Link className='nav-link' aria-current='page' to='/reach-us'>
                Reach Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
